import { render, staticRenderFns } from "./wv-monthly-insights.vue?vue&type=template&id=9a283f84&scoped=true&"
import script from "./wv-monthly-insights.vue?vue&type=script&lang=js&"
export * from "./wv-monthly-insights.vue?vue&type=script&lang=js&"
import style0 from "./wv-monthly-insights.vue?vue&type=style&index=0&id=9a283f84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a283f84",
  null
  
)

export default component.exports